<template>
    <iframe :src="pdf_view_url" width="100%" height="100%" id="pdfIfram" class=" flex-1" key='new' @load="iframeLoaded"></iframe>
  </template>
  
  <script>
    export default {
      name: "PDFWebViewer",
      props: {
        pdfName: String,
        pdfItem: Object,
        pdf_url: String,

        // useType: String //存在代表使用旧版本控件
      },
      data() {
        return {
          pdf_view_url: '',
        }
      },
      watch: {
        pdf_url(val) {
          this.pdfDetailFuc()
        },
      },
      mounted() {
        this.pdfDetailFuc()
      },
      methods: {
        pdfDetailFuc() {
          var that = this;
          that.pdf_view_url = '../../web/pdfjs/web/viewer.html?file=' + this.pdf_url
        },
        //对于PDF中的链接，以新网页打开
        iframeLoaded(event) {
          const iframe = event.target;
          iframe.contentWindow.document.addEventListener('click', (event) => {
            const target = event.target;
            if (target.tagName.toLowerCase() === 'a' && target.href) {
              // 阻止默认行为，防止跳转
              event.preventDefault();
              // 在新窗口打开链接
              window.open(target.href, '_blank');
            }
          });
        }
      }
    };
  </script>
  
  <style>
    #webviewer_id {
      height: 100vh;
    }
  
    iframe {
      width: 100%;
      height: 100%;
      border: 0;
    }
  </style>